import * as React from "react";
import type { SVGProps } from "react";
const SvgBeachUmbrella = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m5.94 3.5.477.823C2.423 7.181.867 12.627 2.9 17.16c.16.36.52.59.91.59l.01-.02h.09a.99.99 0 0 0 .88-.76c.28-1.19.95-1.73 1.32-1.94.86-.49 1.84-.31 2.35-.16.5.15 1.04-.12 1.22-.62a4.883 4.883 0 0 1 1.327-1.973L15.47 20H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1h-3.213l-5.04-8.725a5.125 5.125 0 0 1 2.31-.177.998.998 0 0 0 .262.03.99.99 0 0 0 .961-.768c.3-1.25 1.02-1.78 1.32-1.95.86-.49 1.84-.32 2.34-.17.44.13.91-.06 1.14-.45.21-.35.18-.79-.06-1.11-2.912-4.017-8.394-5.386-12.865-3.36L7.68 2.5c-.28-.48-.89-.65-1.37-.37-.48.28-.65.89-.37 1.37Zm2.87 8.22c-1.373-3.3-1.321-5.764-.55-6.21.763-.446 2.932.749 5.111 3.597-.77.097-1.653.34-2.541.853a6.749 6.749 0 0 0-2.02 1.76ZM5.742 7.742c-1.36 1.816-1.975 4.133-1.653 6.388.37-.4.74-.65 1.02-.82a4.475 4.475 0 0 1 1.959-.58c-.722-1.696-1.222-3.456-1.326-4.988Zm9.374.364c.535-.795 1.156-1.23 1.483-1.416.4-.23.82-.39 1.21-.48a8.65 8.65 0 0 0-5.32-1.82v-.01c-.35 0-.7.02-1.048.063 1.282.859 2.563 2.18 3.675 3.663Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBeachUmbrella;
